<template>
  <div id="modalEditDocument">
    <ModalBoxDialogTour
      width="320px"
      :showModal.sync="show"
      :positionTop="positionTop"
      :positionLeft="positionLeft"
      @hideModal="mixpanelEvent('onlineview_close_edit_tour_document'), hideModal()"
    >
      <template slot="content">
        <div>
          <div class="content-tour">
            <div class="suggestion-header">
              <h3 v-html="$t('Document_Tour.Edit_Document.Head')"></h3>
              <p class="mt-1">
                <i class="fas fa-check mr-1 text-blue"></i>{{ $t("Document_Tour.Edit_Document.Description_1") }}
              </p>
              <p class="mt-1">
                <i class="fas fa-check mr-1 text-blue"></i>{{ $t("Document_Tour.Edit_Document.Description_2") }}
              </p>
              <p class="mt-1">
                <i class="fas fa-check mr-1 text-blue"></i>{{ $t("Document_Tour.Edit_Document.Description_3") }}
              </p>
            </div>
          </div>
          <img :src="`${blobUrl}/peakengine/Content/Image/UserTour/peak.png`" class="peak-image" alt="" />
        </div>
      </template>
    </ModalBoxDialogTour>
  </div>
</template>

<script>
import { DocumentTourStatus } from "@/enums/enums";
import { analytics, event } from "../../../service/analytics/analytics";
export default {
  components: { ModalBoxDialogTour: () => import("./ModalBoxDialogTour") },
  computed: {
    getPackageRecurringDetailLoadingStatus() {
      return this.$store.getters.GetPackageRecurringDetailLoadingStatus;
    },
    packageDetailLoadingStatus() {
      return this.$store.getters.GetPackageDetailLoadingStatus;
    },
  },
  data() {
    return {
      show: true,
      positionTop: "0px",
      positionLeft: "0px",
      screenWidth: 0,
      resizeListener: null,
      blobUrl: process.env.VUE_APP_PeakBlobStorage,
    };
  },
  watch: {
    show(newValue, oldValue) {
      this.hideModal(newValue);
    },
  },
  mounted() {
    this.UpdateScreenWidth();
    this.OnScreenResize();
    this.SetDialogPosition();
  },
  updated() {
    this.$nextTick(() => {
      this.SetDialogPosition();
    });
  },
  watch: {
    positionTop: {
      immediate: true,
      handler(newValue) {
        if (newValue === "0px") {
          this.SetDialogPosition();
          const checkPosition = () => {
            if (this.positionTop === "0px") {
              this.SetDialogPosition();
              setTimeout(checkPosition, 500);
            }
          };
          checkPosition();
        }
      },
    },
    screenWidth(newValue) {
      if (newValue < 1000) {
        this.$router
          .replace({
            name: "receipt",
            query: {
              ...this.$route.query,
              tourEdit: DocumentTourStatus.Hide.toString(),
              tourLogo: DocumentTourStatus.Hide.toString(),
              tourSignature: DocumentTourStatus.Hide.toString(),
            },
          })
          .catch(() => {});
      }
    },
  },
  methods: {
    OnScreenResize() {
      this.resizeListener = () => {
        this.UpdateScreenWidth();
      };
      window.addEventListener("resize", this.resizeListener);
    },
    UpdateScreenWidth() {
      this.SetDialogPosition();
      this.screenWidth = window.innerWidth;
    },
    hideModal() {
      this.$router.replace({
        name: "receipt",
        query: { ...this.$route.query, tourEdit: DocumentTourStatus.Hide.toString() },
      });
    },
    SetDialogPosition() {
      const element = document.querySelectorAll(`[name="documentTourEdit"]`)[0];
      if (element) {
        this.positionTop = `${element.offsetTop + 50}px`;
        this.positionLeft = `${element.offsetLeft - 171}px`;
      }
    },
    DestroyResizeListener() {
      window.removeEventListener("resize", this.resizeListener);
    },
    mixpanelEvent(menu) {
      analytics.emitEvent(event.in_app[menu], { language: this.$i18n.locale });
    },
  },
  beforeDestroy() {
    this.DestroyResizeListener();
  },
};
</script>

<style lang="scss" scoped>
#modalEditDocument {
  p,
  h3 {
    font-size: 18px !important;
    line-height: 1.2 !important;
  }
  .content-tour {
    display: inline-flex;
    flex-direction: column;
    align-self: start;
    gap: 16px;
  }
  .peak-image {
    position: absolute;
    right: 8px;
    bottom: 0;
    width: 103px;
  }
  .suggestion-header {
    display: flex;
    flex-direction: column;
    align-self: start;
    gap: 6px;
  }
  .text-blue {
    color: $blue_default;
  }
}
</style>
